module.exports = __webpack_public_path__ + "static/media/giphy-2.47d32a77.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/giphy-2.gif
// module id = 173
// module chunks = 0